import React, {Component} from 'react';
import lookups from '../lookups.json'; //lookup tables for all the possible choices
import './Dialogs.min.css';

class QuoteDialog extends Component {
    constructor(props) {
        super(props);
    }

    render() {
                     
        //create querystring for quote page
        var url = [];
        url.push("quote.html?a=" + this.props.at);
        url.push("a=" + this.props.a);
        for (var i = 0; i < this.props.data.parameters.length; i++) {
            var choices = [];
            var choice = this.props.data.parameters[i].choice;
            var arrChoices = this.props.data.parameters[i].choices.split(",");
            if (arrChoices[0] == "all") {
                choices = lookups.options[i].choices;
            } else {
                for (var j = 0; j < arrChoices.length; j++) {
                    choices.push(lookups.options[i].choices[arrChoices[j]]);
                }
            }
            url.push(this.props.data.parameters[i].saveVar + "=" + choices[choice].title);
            url.push(this.props.data.parameters[i].saveVar + "=" + choice);
        }
        url.push("cf=" + this.props.customer.firstName);
        url.push("cl=" + this.props.customer.lastName);
        url.push("ce=" + this.props.customer.email);
        url.push("cc=" + this.props.customer.company);
        url.push("cp=" + this.props.customer.phone);
        url.push("cy=" + this.props.customer.country);
        url.push("cn=" + this.props.customer.projectName);
        url.push("urlSite=" + this.props.urlSite);
        url.push("urlDW=" + this.props.urlDW);
        url.push("urlDW2=" + this.props.urlDW2);

        //save SF data
        var url_sf = this.props.urlDW2 + "/Integration?run=MTS_201_Sales&Transition=RequestQuote";

        var customer = [];
        customer.push("CustFirstName=" + this.props.customer.firstName);
        customer.push("CustLastName=" + this.props.customer.lastName);
        customer.push("CustEmail=" + this.props.customer.email);
        customer.push("CustCompany=" + this.props.customer.company);
        customer.push("CustPhone=" + this.props.customer.phone);
        customer.push("CustCountry=" + this.props.customer.country);
        customer.push("CustProject=" + this.props.customer.projectName);
        url_sf+= "&" + customer.join("&");

        
        for(var i = 0; i < this.props.data.parameters.length; i++){
            url_sf+= "&" + this.props.data.parameters[i].dwVar + "=" + (parseInt(this.props.data.parameters[i].choice + 1)); 
        }
                   
        var iframe = document.querySelector("#test_iframe");
        iframe.src = url_sf; //send current setup to second iframe tied to another instance of the DW stuff
        console.log("sent = " + url_sf);

        //wait two seconds to allow Request Quote data to transmit to DW, then go to Quote page
  
        setTimeout(function(){document.location.href = url.join("&");}, 2000);


        return (
          <div id="dlg_customer" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png"/>
                        <div className="dlg_title_txt">User Information</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null, false)}>X</div>
                    </div>
                  <div className="dlg_content">
                      <div className="dlg_white">
                        <div className="dlg_print_spinner">
                            <img src="images/spinner.gif"/>
                            <p className="dlg_head">Saving Request for Quote...</p>
                        </div>
                      </div>
                  </div>
              </div>
          </div>      
       );

        return (null);

    }
}

export default QuoteDialog;
